@let portfolioHasData = portfolioSummary()?.portfolioBalanceSummary?.length > 0;
@if (portfolio) {
  <div [ngClass]="{'overlay': portfolio.priorPeriod}">
    <div class="row portfolio-series-details-row mt-4 mr-0" [ngClass]="{'opacity-70': portfolio.priorPeriod}">
      <div class="card">
        <div class="card-body">
          @if (portfolio.priorPeriod) {
            <app-info-text-box
            [infoText]="'Displaying latest available portfolio data'"></app-info-text-box>
          }
          <div tourAnchor="investor.dashboard.portfolio">
            <div class="title text-lg md:text-2xl flex items-center"
              attr.data-cy="portfolioName{{portfolio.masterId}}">
              <div>
                {{portfolio.name}}
              </div>
              <div class="breadcrumbAsOfDate m-0 mt-1 md:mt-1.5 p-0 md:pl-1 flex" data-cy="asOfDate">as of
                {{portfolio.reportingPeriod | dateFormat : 'MM/dd/yyyy'}}
                @if (portfolio.publishValuationType === 'Audit') {
                  <div data-cy="auditPublished" class="final">-- Final</div>
                }
              </div>
            </div>
            @if(portfolioHasData){
            <div class="row investment-details-row grid gap-4 grid-cols-2 md:grid-cols-6 md:gap-0"
              attr.data-cy="portfolioSummary{{portfolio.masterId}}">
              @let currency = portfolio?.currency;
              @let metrics = [
                {val:portfolio?.commitment, summary: 'Commitment'},
                {val:portfolio?.contributions, summary: 'Contributions'},
                {val:portfolio?.distributions, summary: 'Distributions'},
                {val:portfolio?.nav, summary: 'Net Asset Value'},
              ];

              @for(m of metrics; track m.val) {
                <div class="value-title pr-[42px] md:pr-4">
                  <div class="md:float-left md:relative">
                    <h3 class="summary-value" data-cy="balanceValue">
                      {{m.val | currencyFormat:currency}}
                    </h3>
                    <span class="summary-title">{{m.summary}}</span>
                  </div>
                </div>
              }

              <div class="value-title">
                <div class="md:float-left md:relative">
                  <h3 class="summary-value flex">
                    <span data-cy="tvpiValue"
                    [ngClass]="{'no-icon': !portfolio?.tvpiIcon}">{{portfolio?.formattedTvpi}}</span>
                    @if (portfolio?.tvpiIcon) {
                      <img src="{{portfolio?.tvpiIcon}}" alt="sample img"
                        [matTooltip]="portfolio?.tvpiTitle" matTooltipClass="blue-tooltip"
                        matTooltipPosition="right" class="widget-img"
                        attr.data-cy="tvpiIcon{{portfolio.masterId}}">
                    }
                  </h3>
                  <span class="summary-title with-icon">Net TVPI</span>
                </div>
              </div>
              <div class="value-title">
                <div class="md:float-left md:relative">
                  <h3 class="summary-value flex">
                    <span data-cy="irrValue"
                    [ngClass]="{'no-icon': !portfolio?.irrIcon}">{{portfolio?.formattedIrr }}</span>
                    @if (portfolio?.irrIcon) {
                      <img src="{{portfolio?.irrIcon}}" alt="sample img"
                        [matTooltip]="portfolio?.irrTitle" matTooltipClass="blue-tooltip"
                        matTooltipPosition="right" class="widget-img"
                        attr.data-cy="irrIcon{{portfolio.masterId}}">
                    }
                  </h3>
                  <span class="summary-title with-icon">Net IRR</span>
                </div>
              </div>
            </div>
            }
          </div>
          @if (portfolio) {
            <div class="ccd-chart">
              @if (portfolioHasData) {
              <app-cumulative-chart [cumulativeData]="portfolio"
              [selectedAsOfDate]="selectedAsOfDate()"></app-cumulative-chart>
              }
            </div>
          }
          @for (series of portfolio.portfolioSeries | sortBy:'asc' : 'ticker'; track series.ticker; let j = $index) {
            <div [tourAnchor]="j === 0 ? 'investor.dashboard.series' : ''">
              <div class="portfolio-series" [ngClass]="{'br-top-rounded': series.isExpanded}"
                [tourAnchor]="j === 0 ? 'investor.dashboard.series.drillThrough' : ''">
                <div class="series-row row grid gap-4 grid-cols-2 md:grid-cols-6 md:gap-0"
                  attr.data-cy="seriesSummary{{portfolio.masterId}}{{j}}">
                  <div class="col-span-4 series-name">
                    @if (!series.hasCommitments || portfolio.priorPeriod) {
                      <span
                        class="series-title series-title-disabled" matTooltipClass="blue-tooltip-xl"
                        matTooltipPosition="above" [matTooltip]="'No Investment Data Available'"
                        [matTooltipDisabled]="portfolio.priorPeriod"
                      attr.data-cy="seriesName{{series.masterId}}">{{series.name}}</span>
                    }
                    @if (series.hasCommitments && !portfolio.priorPeriod) {
                      <a class="series-title"
                        routerLinkActive="active" [routerLink]="series.routerLink"
                        [queryParams]="series.queryParams"
                        (click)="activityTracking.navigateToDashboard('Series', series, 'investor dashboard')"
                      attr.data-cy="seriesName{{series.masterId}}">{{series.name}}</a>
                    }
                    @for (assetImage of series.assetClassImage; track assetImage[0]; let k = $index) {
                      <img class="investment-type" [src]="assetImage[1]" alt="asset image"
                        attr.data-cy="assetImage{{portfolio.masterId}}{{j}}{{k}}"
                        [matTooltip]="assetImage[0]" matTooltipClass="blue-tooltip"
                        matTooltipPosition="right">
                      }
                    </div>
                    <div class="value-title pl-0">
                      <div class="md:float-left md:relative pr-4">
                        <span class="series-title flex">
                          <span data-cy="tvpiValue"
                          [ngClass]="{'no-icon': !series?.tvpiIcon}">{{series?.formattedTvpi}}</span>
                          @if (series?.tvpiIcon) {
                            <img
                              attr.data-cy="tvpiIcon{{portfolio.masterId}}{{series.masterId}}"
                              src="{{series.tvpiIcon}}" alt="sample img" class="widget-img"
                              [matTooltip]="series.tvpiTitle" matTooltipClass="blue-tooltip"
                              matTooltipPosition="right">
                          }</span>
                          <span class="series-labels">Net TVPI</span>
                        </div>
                      </div>
                      <div class="value-title pl-0">
                        <div class="md:float-left md:relative pr-4">
                          <span class="series-title flex">
                            <span data-cy="irrValue"
                            [ngClass]="{'no-icon': !series?.irrIcon}">{{series?.formattedIrr}}</span>
                            @if (series?.irrIcon) {
                              <img
                                attr.data-cy="irrIcon{{portfolio.masterId}}{{series.masterId}}"
                                src="{{series.irrIcon}}" alt="sample img" class="widget-img"
                                [matTooltip]="series.irrTitle" matTooltipClass="blue-tooltip"
                                matTooltipPosition="right">
                            }</span>
                            <span class="series-labels">Net IRR</span>
                          </div>
                        </div>
                      </div>
                      @if (!series.isExpanded) {
                        <img class="down-icon" (click)="expandSeriesPortfolio(series, true)" (keydown.enter)="expandSeriesPortfolio(series, true)" tabindex="0"
                          src="{{iconSet()?.['icon.expand']}}" alt="Expand series"
                          attr.data-cy="expandIcon{{portfolio.masterId}}{{series.masterId}}">
                        }
                      </div>
                      @if (series.isExpanded) {
                        <img class="up-icon mt-[-35px]" (click)="collapseSeriesPortfolio(series)" (keydown.enter)="collapseSeriesPortfolio(series)" 
                          tabindex="0" role="button" alt="Collapse series" src="{{iconSet()?.['icon.collapse']}}"
                          attr.data-cy="collapseIcon{{portfolio.masterId}}{{series.masterId}}">
                          <div class="portfolio-expanded-container"
                            attr.data-cy="expandedViews{{portfolio.masterId}}{{series.masterId}}">
                            <div class="expanded-view grid gap-4 grid-cols-1 lg:grid-cols-3 lg:gap-0">
                              <div class="widgets">
                                <app-series-commitment-widget [series]="series"
                                  [portfolioId]="portfolio.masterId"
                                [currency]="currency"></app-series-commitment-widget>
                              </div>
                              <div class="widgets">
                                <app-series-ccd-widget [series]="series" [portfolioId]="portfolio.masterId"
                                  [currency]="currency" [selectedAsOfDate]="selectedAsOfDate()"
                                [isMobileDevice]="isMobileDevice()"></app-series-ccd-widget>
                              </div>
                              <div class="widgets">
                                <app-series-distributions-widget [series]="series"
                                  [portfolioId]="portfolio.masterId"
                                [currency]="currency"></app-series-distributions-widget>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
